<template>
  <div>
    <b-tabs>
      <b-tab title="Manual Deposit" v-if="checkAccessPrivilege('Payment.Level.BankMaintenance.ManualDeposit')"><manual-deposit/></b-tab>
      <b-tab title="Auto Cash In" v-if="checkAccessPrivilege('Payment.Level.BankMaintenance.AutoCashIn')"><auto-cash-in/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AutoCashIn from './BankAccount/AutoCashIn'
import ManualDeposit from './BankAccount/ManualDeposit'

export default {
  name: 'vip-level-bank-account-table',
  data: () => {
    return {
    }
  },
  components: {
    AutoCashIn,
    ManualDeposit
  },
  methods: {
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelBankAccountTable.vue